import React, { useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { sortBy } from 'lodash/fp';
import { useUser } from '../../../../utils/hooks/auth';
import {
    UpdateWarehouseMutationVariables,
    WarehouseComponent,
    useGetInitInfoQuery,
    useUpdateWarehouseMutation,
} from '../../../../generated/graphql';
import { WAREHOUSES_QUERY } from '../../graphql/queries';
import { routePaths } from '../../../../routePaths';
import { FullScreenDialog } from '../../../../ui-kit';
import WarehouseForm, { WarehouseFormValues } from './WarehouseForm';

const UpdateWarehouseForm = () => {
    const [isDialogOpened, setIsDialogOpened] = useState(true);
    const theme = useTheme();
    const history = useHistory();
    const { params: { id: warehouseId } } = useRouteMatch();
    const { user: { currentVenueId } } = useUser();
    const { data } = useGetInitInfoQuery({ fetchPolicy: 'cache-only' });

    const venues = data ? data.venues : [];
    const sortedVenues = sortBy(['name', 'asc'], venues);

    const [runMutation] = useUpdateWarehouseMutation({ refetchQueries: [{ query: WAREHOUSES_QUERY }] });

    const onClose = () => {
        setIsDialogOpened(false);
        setTimeout(() => history.push(routePaths.warehouses), theme.transitions.duration.leavingScreen);
    };


    const onSubmit = async ({ name, venueIds }: WarehouseFormValues) => {
        const variables: UpdateWarehouseMutationVariables = {
            id: warehouseId,
            name,
            venueIds,
        };
        await runMutation({ variables });
        onClose();
    };

    const { t } = useTranslation();

    return (
        <FullScreenDialog isOpened={isDialogOpened}>
            <WarehouseComponent variables={{ id: warehouseId }}>
                {({ data: { warehouse } }) => (
                    <WarehouseForm
                        buttonText={t('Update')}
                        dialogName={t('Update warehouse')}
                        initialValues={{
                            name: warehouse.name,
                            venueIds: warehouse.venueIds,
                        }}
                        onClose={onClose}
                        currentVenueId={currentVenueId}
                        onSubmit={onSubmit}
                        venues={sortedVenues}
                    />
                )}
            </WarehouseComponent>
        </FullScreenDialog>
    );
};

export default UpdateWarehouseForm;
